var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadFileIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8116_42474",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.135498,
    y: 0.15625,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8116_42474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1354 14.1568L14.8101 11.4821L13.8768 10.5488L12.8021 11.6234V8.8401H11.4688V11.6234L10.3941 10.5488L9.46078 11.4821L12.1354 14.1568ZM9.46878 16.1568V14.8234H14.8021V16.1568H9.46878ZM4.22712 13.5818C3.80734 13.5818 3.44962 13.4339 3.15395 13.1383C2.85828 12.8426 2.71045 12.4849 2.71045 12.0651V2.9151C2.71045 2.49533 2.85828 2.1376 3.15395 1.84194C3.44962 1.54627 3.80734 1.39844 4.22712 1.39844H8.90178L12.8938 5.39044V7.50677H11.3771V6.1886H8.10362V2.9151H4.22712V12.0651H8.13545V13.5818H4.22712Z",
    fill: "#1D5AE8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFileIcon);
export default __webpack_public_path__ + "static/media/DownloadFileIcon.8b2af331c9f02fdeefd78d2a51461524.svg";
export { ForwardRef as ReactComponent };